import i18n from 'i18n/i18n'

const updateLanguageAttribute = (language: string) => {
  document.documentElement.lang = language
}

export const syncLanguageAttribute = () => {
  updateLanguageAttribute(i18n.language)

  i18n.on('languageChanged', updateLanguageAttribute)
}
